import { IonButton, IonHeader, IonModal, IonToolbar } from "@ionic/react";
import { Report } from "../utils/Interfaces";
import "../theme/GlobalStyles.css";
import { UtilFunctions } from "../utils/UtilFunctions";
import { useState } from "react";
import GoogleMapReact from "google-map-react";
import { MAPS_API_KEY } from "../utils/Constants";
import MapMarker from "./MapMarker";

function ModalRow({
  prop,
  value,
  showMapButton = false,
  lat,
  lng,
}: {
  prop: string;
  value: string;
  showMapButton?: boolean;
  lat?: number;
  lng?: number;
}) {
  const [showMap, setShowMap] = useState(false);
  return (
    <div className="modalRow">
      <div style={{ display: "flex", flexDirection: "row" }}>
        <p className="modalRowProp">{prop}</p>
        <p className="modalRowValue">{value}</p>
      </div>
      {showMapButton && (
        <div className="mapButtonContainer">
          <IonButton className="yellowBtn" onClick={() => setShowMap(!showMap)}>
            {showMap ? "Hide map" : "View map"}
          </IonButton>
        </div>
      )}
      {showMap && (
        <div className="minimap">
          <GoogleMapReact
            yesIWantToUseGoogleMapApiInternals
            bootstrapURLKeys={{ key: MAPS_API_KEY }}
            defaultCenter={{ lat: lat!, lng: lng! }}
            defaultZoom={15}
          >
            <MapMarker lat={lat!} lng={lng!} handleClick={() => {}} />
          </GoogleMapReact>
        </div>
      )}
    </div>
  );
}

const ReportModal = ({
  selectedReport,
  showModal,
  setShowModal,
}: {
  selectedReport: Report | undefined;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}) => {
  const [showMap, setShowMap] = useState(false);

  return (
    <IonModal
      backdropDismiss={true}
      onWillDismiss={() => setShowModal(false)}
      isOpen={showModal}
      className="reportModal"
    >
      <IonHeader>
        <IonToolbar>
          <div id="toolbarContent">
            <div className="toolbarSides" />
            <p>Report</p>
            <div className="toolbarSides">
              <button type="button" className="closeBtn" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
          </div>
        </IonToolbar>
      </IonHeader>
      <div id="modalContentContainer">
        <div id="modalContainer">
          <ModalRow prop={"Id"} value={selectedReport?.id!} />
          <ModalRow prop={"Name"} value={selectedReport?.carWashName!} />
          <ModalRow prop={"Created"} value={UtilFunctions.formatDate(selectedReport?.dateTimeCreated!)} />
          {selectedReport?.manualAddress?.streetName !== "" ? (
            <>
              {/* location permission not given so show manual address fields */}
              <ModalRow prop={"Street Name"} value={selectedReport?.manualAddress?.streetName!} />
              <ModalRow prop={"Postcode"} value={selectedReport?.manualAddress?.postcode!} />
              <ModalRow prop={"Town"} value={selectedReport?.manualAddress?.town!} />
            </>
          ) : (
            <>
              {/* location permission given so show detected address fields */}
              <ModalRow prop={"Street Number"} value={selectedReport?.detectedAddress?.streetNumber!} />
              <ModalRow prop={"Route"} value={selectedReport?.detectedAddress?.route!} />
              <ModalRow prop={"City"} value={selectedReport?.detectedAddress?.city!} />
              <ModalRow prop={"District"} value={selectedReport?.detectedAddress?.district!} />
              <ModalRow prop={"Postal Code"} value={selectedReport?.detectedAddress?.postalCode!} />
              <ModalRow prop={"Region"} value={selectedReport?.detectedAddress?.region!} />
              <ModalRow prop={"Country"} value={selectedReport?.detectedAddress?.country!} />
            </>
          )}
          <ModalRow prop={"County"} value={selectedReport?.county!} />
          <ModalRow prop={"Police Area"} value={selectedReport?.policeArea!} />
          <ModalRow prop={"Local Authority"} value={selectedReport?.localAuth!} />
          <ModalRow
            prop={"Location"}
            value={
              selectedReport?.latitude == 0 && selectedReport?.longitude == 0
                ? "The user didn't grant location permissions"
                : `${selectedReport?.latitude!.toString()}, ${selectedReport?.longitude!.toString()}`
            }
            showMapButton={selectedReport?.latitude != 0 && selectedReport?.longitude != 0}
            lat={selectedReport?.latitude}
            lng={selectedReport?.longitude}
          />
          {showMap && <div style={{ width: "100px", height: "100px", backgroundColor: "blue" }}></div>}
          <ModalRow prop={"MSH"} value={selectedReport?.sentMSH!} />
          <ModalRow prop={"Score"} value={selectedReport?.score!} />
          {selectedReport?.questionAndAnswers.map((qa, index) => (
            <ModalRow key={index} prop={qa.question} value={qa.answer} />
          ))}
        </div>
      </div>
    </IonModal>
  );
};

export default ReportModal;
